<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dQHssk/tc-custom/9781464206382.jpg?1730640568939" alt="This image is the cover for the book Few Right Thinking Men, Rowland Sinclair WWII Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Few Right Thinking Men, Rowland Sinclair WWII Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An amateur sleuth searches for a killer among the aristocracy in 1930s Australia in a novel by the author of <i>The Woman in the Library</i>: “[A] witty hero.” —<i>Library Journal</i> (starred review)</b><br/><br/><i>Finalist, Commonwealth Writers’ Prize for Best First Book</i><br/><br/> Sydney, 1931. Rowland Sinclair doesn’t fit with his family. His conservative older brother, Wilfred, thinks he’s reckless, a black sheep; his aging and declining mother thinks he’s her son who was killed in the war. Only his namesake, Uncle Rowly, a kindred spirit, understands him—and now he’s been brutally murdered in his own home.<br/><br/> The police are literally clueless, and so Rowly takes it upon himself to crack the mystery. In order to root out the guilty party, he uses his wealth and family influence to infiltrate the upper echelons of both the old and the new guard, playing both against the middle in a desperate and risky attempt to find justice for his uncle. With his bohemian housemates—a poet, a painter, and a free-spirited sculptress—watching his back, Rowly unwittingly exposes a conspiracy that just might be his undoing.<br/><br/> “Will delight traditional mystery buffs.” ―<i>Library Journal</i> (starred review)<br/>  <br/> “Fans of Kerry Greenwood’s Phryne Fisher series, rejoice.” ―<i>Historical Novels Review</i><br/>  <br/> “The plot effectively plays Sinclair’s aristocratic bearing and involvement in the arts against the Depression setting, fraught with radical politics . . . And Sinclair himself is a delight: winning us over completely and making us feel as though he’s an old friend.” ―<i>Booklist</i> (starred review) </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sulari Gentill
      </h2>
      
      <p class="authorDescription body article"><P>After setting out to study astrophysics, graduating in law and then abandoning her legal career to write books, SULARI GENTILL now grows French black truffles on her farm in the foothills of the Snowy Mountains of Australia.</P><P>Gentill’s Rowland Sinclair mysteries have won and/or been shortlisted for the Davitt Award and the Commonwealth Writers’ Prize, and her stand-alone metafiction thriller, After She Wrote Him won the Ned Kelly Award for Best Crime Novel in 2018. Her tenth Sinclair novel, A Testament of Character, was shortlisted for the Ned Kelly Best Crime Novel in 2021.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7e4a86e8